import React from 'react';

import PropTypes from 'prop-types';

import { FormField } from 'components';

const TimeRangeSelector = ({ label, value, onChange }) => {
  return (
    <div className="space-y-2">
      <FormField
        label={`${label} (Start Time)`}
        type="time"
        value={value?.start || ''}
        onChange={e => onChange({ ...value, start: e.target.value })}
      />
      <FormField
        label={`${label} (End Time)`}
        type="time"
        value={value?.end || ''}
        onChange={e => onChange({ ...value, end: e.target.value })}
      />
    </div>
  );
};

TimeRangeSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default TimeRangeSelector;
